/* eslint-disable @typescript-eslint/no-explicit-any */
import * as types from "../../actionTypes/Dashboard/eurailTicketActionTypes";

export const eurailTicketStationListAction = {
  STARTED: (args: any) => ({
    type: types.EURAIL_STATION_LIST.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.EURAIL_STATION_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.EURAIL_STATION_LIST.REJECTED }),
};

export const eurailTicketStationToListAction = {
  STARTED: (args: any) => ({
    type: types.EURAIL_STATION_TO_LIST.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.EURAIL_STATION_TO_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.EURAIL_STATION_TO_LIST.REJECTED }),
};

export const eurailTicketSearchAction = {
  STARTED: (args: any) => ({
    type: types.EURAIL_TICKET_SEARCH.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.EURAIL_TICKET_SEARCH.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.EURAIL_TICKET_SEARCH.REJECTED }),
};

export const getEurailTicketListAction = {
  STARTED: (args: any) => ({
    type: types.GET_EURAIL_TICKET_LIST.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_EURAIL_TICKET_LIST.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_EURAIL_TICKET_LIST.REJECTED }),
};

export const getEurailTicketHSID = {
  FULLFILLED: (results: any) => ({
    type: types.GET_EURAIL_TICKET_HSID.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_EURAIL_TICKET_HSID.REJECTED }),
};

export const eurailTicketPreBookAction = {
  STARTED: (args: any) => ({
    type: types.EURAIL_TICKET_PRE_BOOK.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.EURAIL_TICKET_PRE_BOOK.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.EURAIL_TICKET_PRE_BOOK.REJECTED }),
};

export const eurailTicketCheckoutAction = {
  STARTED: (args: any) => ({
    type: types.EURAIL_TICKET_CHECKOUT.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.EURAIL_TICKET_CHECKOUT.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.EURAIL_TICKET_CHECKOUT.REJECTED }),
};

export const eurailConfigKeyAction = {
  STARTED: (args: any) => ({
    type: types.EURAIL_CONFIG_KEY.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.EURAIL_CONFIG_KEY.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.EURAIL_CONFIG_KEY.REJECTED }),
};

export const getEurailBookingDetailsAction = {
  STARTED: (args: any) => ({
    type: types.GET_EURAIL_BOOKING_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.GET_EURAIL_BOOKING_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.GET_EURAIL_BOOKING_DETAILS.REJECTED }),
};

export const getAgentEurailBookingDetailsAction = {
  STARTED: (args: any) => ({
    type: types.AGENT_GET_EURAIL_BOOKING_DETAILS.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.AGENT_GET_EURAIL_BOOKING_DETAILS.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.AGENT_GET_EURAIL_BOOKING_DETAILS.REJECTED }),
};

export const eurailSegmentChargesAction = {
  STARTED: (args: any) => ({
    type: types.EURAIL_SEGMENT_CHARGES.STARTED,
    payload: args,
  }),
  FULLFILLED: (results: any) => ({
    type: types.EURAIL_SEGMENT_CHARGES.FULLFILLED,
    payload: results,
  }),
  REJECTED: () => ({ type: types.EURAIL_SEGMENT_CHARGES.REJECTED }),
};
